module.exports = __webpack_public_path__ + "static/media/logo-no-smoking.e3c2c91b.svg";